import React, { useEffect, useState } from 'react';
import * as api from '../../billMemory/api';
import { vendorProgressText } from '../../billMemory/client';

/**
 * Bill Memory vendor progress (Fix plan, Fix 12): one grey line under the vendor field —
 * "<Vendor>: your first bill needed 9 taps; this one needs 1." — from the vendor's 3rd bill, when the
 * taps fell and a source is On. `need` is the rows on this bill still needing a tap. Nothing on error.
 */
export default function VendorProgressLine({ vendorId, need, on }) {
  const [progress, setProgress] = useState(null);
  useEffect(() => {
    setProgress(null);
    if (!on || !vendorId) return undefined;
    let cancelled = false;
    api.getVendorProgress(vendorId).then((r) => { if (!cancelled && r && r.success) setProgress(r); }).catch(() => {});
    return () => { cancelled = true; };
  }, [vendorId, on]);
  const text = vendorProgressText(progress, need, on);
  if (!text) return null;
  return <div className="stockin-unit-cost-display"><span>{text}</span></div>;
}
